import { captureException, captureMessage } from "@sentry/nextjs";

export const removeDuplicatedObjects = (
  arrayWithDuplicatedObjects,
  optionalID = null,
) => {
  let normalizedArray = [...(arrayWithDuplicatedObjects ?? [])];

  try {
    const seenIds = new Set();

    const ID = optionalID ?? "id";

    normalizedArray = arrayWithDuplicatedObjects?.filter((obj) => {
      if (!seenIds?.has(obj?.[ID])) {
        seenIds?.add(obj?.[ID]);
        return true;
      }
      return false;
    });
  } catch (error) {
    console.log("Erro (removeDuplicatedObjects): ", error);
    captureException(error);
    captureMessage("Error (removeDuplicatedObjects): ");
  }

  return normalizedArray;
};
